/** How long to wait for an image before treating it as missing. A picture that takes longer is not worth holding the preview for. */
export const IMAGE_PROBE_TIMEOUT_MS = 4000

/**
 * Whether the image at this address loads. A notification preview draws a broken picture for an address that
 * answers with an error or never answers, and a broken picture says nothing true about the notification, so
 * the preview asks first and leaves the image out when the answer is no.
 */
export const imageLoads = (url: string, timeoutMs: number = IMAGE_PROBE_TIMEOUT_MS): Promise<boolean> =>
    new Promise((resolve) => {
        const image = new Image()
        const finish = (loaded: boolean) => {
            clearTimeout(timer)
            image.onload = null
            image.onerror = null
            resolve(loaded)
        }
        const timer = setTimeout(() => finish(false), timeoutMs)

        image.onload = () => finish(true)
        image.onerror = () => finish(false)
        image.src = url
    })
